import detectTouch from './touch';

detectTouch();



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/feature-detects/index.js